var map = {
	"./privatePolicy-de.vue": [
		"oZJk",
		11
	],
	"./privatePolicy-en.vue": [
		"QeKR",
		10
	],
	"./privatePolicy-es.vue": [
		"UazA",
		9
	],
	"./privatePolicy-fr.vue": [
		"pg06",
		8
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "WUj0";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/pages/privatepolicy lazy ^\.\/privatePolicy\-.*\.vue$
// module id = WUj0
// module chunks = 17